/**
 * Structured logger for frontend.
 * Centralizes console output with consistent format and context.
 * In production, errors could be forwarded to an external service.
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

interface LogContext {
  component?: string
  action?: string
  userId?: string
  [key: string]: unknown
}

const isProd = process.env.NODE_ENV === 'production'

function formatMessage(level: LogLevel, message: string, context?: LogContext): string {
  const timestamp = new Date().toISOString()
  const prefix = context?.component ? `[${context.component}]` : ''
  return `${timestamp} ${level.toUpperCase()} ${prefix} ${message}`
}

export const logger = {
  debug(message: string, context?: LogContext): void {
    if (!isProd) {
      console.log(formatMessage('debug', message, context), context || '')
    }
  },

  info(message: string, context?: LogContext): void {
    console.log(formatMessage('info', message, context), context || '')
  },

  warn(message: string, context?: LogContext): void {
    console.warn(formatMessage('warn', message, context), context || '')
  },

  error(message: string, error?: unknown, context?: LogContext): void {
    console.error(formatMessage('error', message, context), error || '', context || '')
  },
}
